// src/store/modules/account.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import {
    API_ISBIND_INFO,
    APP_ISBIND_FAILURE
} from '../../../config/mutation-types'

import {
    API_AI
} from '../../../config/const'


const state = {
    apiInfo: ''
}

const getters = {
    getIsBind: state => state.apiInfo
}

const actions = {
    getIsBind({commit}, options) {
        var uri = API_AI + "/h5/auth/checkThirdPartyUser/" + options.data.methodid + "/" + options.data.openid + "/" + options.data.unionid
        if(options.data.from && options.data.redirect){
            uri += '?from=' + options.data.from + '&redirect=' + options.data.redirect
        }
        return new Promise((resolve, reject) => {
            Vue.http.get(uri).then((res, err) => {
                    resolve(res.data)
                }, (res) => {
                    reject(res.data)
                })
            }).then((res) => {
                commit(API_ISBIND_INFO, res)
            }, (err) => {
                commit(APP_ISBIND_FAILURE, err + '获取信息失败')
            })
    }
}

const mutations = {
    [API_ISBIND_INFO](state, data) {
        state.apiInfo = data
    },
    [APP_ISBIND_FAILURE](state, data) {
        state.apiInfo = data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/login/checkIsBind.js